import React from 'react';
import { TACTICS_PREFERENCE_NOTE } from '../../../constants/coachTactics';

/**
 * The line that stands above PLAYING STYLE, OFFENSIVE TACTICS and DEFENSIVE
 * TACTICS, on the coach's own profile and on the public one.
 *
 * It is there because the three sections are easy to misread as a record: a
 * list of terms next to a man's name looks like something the platform checked
 * and is passing on. It is not. Nothing here is verified, counted or filtered
 * on; every word is the coach's own account of how he works. Saying that once,
 * quietly, above the block is the whole job — which is why this renders one
 * sentence pair and nothing else, and why it carries no heading that would turn
 * it into a fourth section.
 */
const CoachingPreferencesNote = ({ wrapperClassName = '' }) => (
  <div className={wrapperClassName}>
    <p className="text-sm text-[#646B7E]">{TACTICS_PREFERENCE_NOTE}</p>
  </div>
);

export default CoachingPreferencesNote;
